<template>
  <v-container fluid v-if="value" pa-0>
    <v-layout row justify-center>
      <v-flex xs12 sm8 lg5 xl4>
        <v-card-title class="headline pa-0">
            <span v-if="!grassroots">Random Streamer</span>
            <span v-if="grassroots">
              <v-tabs v-model="selectedStream">
                <v-tab>Grassroots</v-tab>
                <v-tab>Random</v-tab>                
              </v-tabs>
            </span>
            <v-spacer></v-spacer>
            <v-icon @click="refresh" v-if="selectedStream == 1 || !grassroots">mdi-reload</v-icon>
        </v-card-title>
        <v-divider></v-divider>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-center mt-1>
      <v-flex xs12 sm8 lg5 xl4>
        <v-tabs-items v-model="selectedStream">
          <v-tab-item v-if="grassroots">
            <twitch-stream-card :stream="grassroots" high-quality />    
          </v-tab-item>
          <v-tab-item>
            <twitch-stream-card :stream="value" high-quality />    
          </v-tab-item>
        </v-tabs-items>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import TwitchStreamCard from '@/components/TwitchStreamCard'

export default {
  name: 'FeatureStreamer',
    components: {
    TwitchStreamCard,
  },
  props: [
    'value',
    'grassroots'
  ],
  data () {
    return {
      selectedStream: 0,
    }
  },
  methods: {
    refresh() {
      this.$emit('refresh')
    },
  },
}
</script>

<style>
</style>
